<template>
  <div class="topPanel">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'topPanel'
}
</script>

<style lang="scss" scoped>
.topPanel {
  height: 47px;
  line-height: 47px;
  margin: 0 30px;
  font-size: 16px;
  color: #262626;
  border-bottom: 1px solid #ebebeb;
}
</style>
